<div class="wrapper">
  <div class="thankyou-bg">
    <div class="logo pointer">
      <img src="./assets/images/logo.png" />
      <span style="margin-left: 90px !important" class="trademark2">™</span>
    </div>
    <div class="thankyou-box box-shadow">
      <div *ngIf="updateAvailable" class="warning">
        <p>Version ({{ latestAppVersion }}) is available, please download and update the app.</p>
      </div>
      <div *ngIf="!updateAvailable" class="warning">
        <p>Version is up to date!</p>
      </div>
      <div *ngIf="updateAvailable" class="download-btn-group">
        <a href="https://www.titaniumsecure.io:3000/download/getlatestapk" target="_black" style="margin-top: 15px;" class="btn btn-blue pointer"><i class="fab fa-android"></i> Android (APK)</a>
      </div>
    </div>
  </div>
</div>
<div class="wrapper" *ngIf="error">
  <div class="thankyou-bg">
    <div class="logo pointer">
      <img src="./assets/images/logo.png" />
      <span style="margin-top: 20px !important; margin-left: 90px !important" class="trademark2">™</span>
    </div>
    <div class="thankyou-box box-shadow">
      <img src="" />
      <p>{{error}}</p>
      <div class="download-btn-group">
      </div>
    </div>
  </div>
</div>
